import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import * as _ from "underscore";
import { UserData } from "../shared/service/UserService";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AnalyticService {
  private apiUrl: string;
  private header;
  private headerAppJSON;

  constructor(private http: HttpClient) {
    this.apiUrl = UserData.backend_url + "/v1";
    this.header = this.getHeader();
    this.headerAppJSON = this.getHeaderAppJSON();
  }

  public getHeader() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
      }),
    };
    return httpOptions;
  }

  public getHeaderAppJSON() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
        "Content-Type": "application/json",
      }),
    };
    return httpOptions;
  }

  public getAnalyticsForTeamsAndUsers() {
    const url = this.apiUrl + "/analytics/userAndTeamUsage";
    return this.http.get(url, this.header);
  }

  public getAnalyticsForPSetsAndFolders() {
    const url = this.apiUrl + "/analytics/practiceSetAndFolderUsage";
    return this.http.get(url, this.header);
  }

  public getDifficultPSets() {
    const url = this.apiUrl + "/analytics/practiceSetDifficultyUsage";
    return this.http.get(url, this.header);
  }

  public getPracticeSetData(data, dataID: string) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?day=" + data;
    else if (data == "month") url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?month=" + data;
    else if (data == "year") url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?year=" + data;
    return this.http.get(url, this.header);
  }

  public getDifficultPOnDateRangeSets(fromDate, toDate, dataID: string) {
    const url = this.apiUrl + "/analytics/practiceSetDifficultyUsage?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByDay(date, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedUsage?fromDate=" + date;
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByMonth(date, dataID: string) {
    console.log("here inside month");

    const url = this.apiUrl + "/analytics/sessionsPlayedMonths?fromDate=" + date;
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByYear(date, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedYear?fromDate=" + date;
    return this.http.get(url, this.header);
  }

  public getSessionsPlayedByDateRange(fromDate, toDate, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedCustomRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  //Masterd Practice Set

  public getMasteredPracticeSetByDay(date, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredUsage?fromDate=" + date;
    return this.http.get(url, this.header);
  }

  public getMasteredPracticeSetByMonth(date, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredMonths?fromDate=" + date;
    return this.http.get(url, this.header);
  }

  public getMasteredPracticeSetByYear(date, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredYear?fromDate=" + date;
    return this.http.get(url, this.header);
  }

  public getMasteredPracticeSetByDateRange(fromDate, toDate, dataID: string) {
    const url = this.apiUrl + "/analytics/sessionsPlayedMasteredCustomRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getLastActiveUsers(fromDate, toDate, flag) {
    let url: any = "";
    if (flag) url = this.apiUrl + "/analytics/lastActiveUsersDetailRange";
    else url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getActiveUsersData(type, data) {
    let url: any = "";
    if (type == "day") url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?day=" + data;
    else if (type == "month") url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?month=" + data;
    else if (type == "year") url = this.apiUrl + "/analytics/lastActiveUsersDetailRange?year=" + data;
    return this.http.get(url, this.header);
  }

  public getCsvData(analyticType: any, selectedDateType: any, startDate: any, endDate: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url = this.apiUrl + "/generalAnalytics/recordUsage?analyticsType=" + analyticType + "&usageType=" + selectedDateType;
      } else {
        url = this.apiUrl + "/generalAnalytics/recordUsage?analyticsType=" + analyticType + "&fromDate=" + startDate + "&toDate=" + endDate;
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }
}
